export default {
  tag: {
    type: String,
    default: 'div',
  },
}



// WEBPACK FOOTER //
// ./src/utils/propsTag.js